import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { cardStyle, primaryBtn, primaryBtnHover, logoIconStyle, white, textPrimary, bgMuted } from './styles'
import { getApiUrl } from './gameLogic'
import EventProBrand from './EventProBrand'

function StartScreen({ onNameSet }) {
  const [nameInput, setNameInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [isHovering, setIsHovering] = useState(false)

  const apiBaseUrl = getApiUrl()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!nameInput.trim()) {
      setError('Please enter a name')
      return
    }

    setLoading(true)
    setError('')

    try {
      // Try to verify existing name
      const verifyResponse = await fetch(`${apiBaseUrl}/eventpro/verify-name/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ player_name: nameInput }),
      })

      if (!verifyResponse.ok) {
        // Name doesn't exist, reserve it
        const reserveResponse = await fetch(`${apiBaseUrl}/eventpro/reserve-name/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ player_name: nameInput }),
        })

        if (!reserveResponse.ok) {
          const data = await reserveResponse.json()
          setError(data.error || 'Failed to reserve name')
          setLoading(false)
          return
        }
      }

      // Success
      onNameSet(nameInput)
    } catch (err) {
      setError('Network error. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: bgMuted, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ maxWidth: '420px', width: '100%' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}><EventProBrand size="login" /></div>
          <p style={{ margin: '8px 0 0 0', fontSize: '0.9rem', color: '#666' }}>Pop Culture. Accuracy first. Then time.</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ ...cardStyle }}>
          <label style={{ display: 'block', marginBottom: '12px', fontSize: '0.85rem', fontWeight: '600', color: '#555' }}>
            Enter Your Name
          </label>
          <input
            type="text"
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
            placeholder="Your display name"
            style={{
              width: '100%',
              padding: '12px 14px',
              fontSize: '16px',
              borderRadius: '8px',
              border: '1px solid #d3d6da',
              marginBottom: '16px',
              fontFamily: 'inherit',
              color: textPrimary,
            }}
            disabled={loading}
          />

          {error && (
            <div style={{ marginBottom: '16px', padding: '12px', borderRadius: '6px', backgroundColor: '#fef2f2', border: '1px solid #dc2626', color: '#991b1b', fontSize: '0.9rem' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={isHovering && !loading ? primaryBtnHover : primaryBtn}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          >
            {loading ? 'Loading...' : 'Start Playing'}
          </button>

          <p style={{ marginTop: '16px', fontSize: '0.8rem', color: '#999', textAlign: 'center' }}>
            Your name is your player ID. You can play from any device.
          </p>
        </form>

        {/* How to Play Link */}
        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <Link to="/how-to-play" style={{
            fontSize: '0.85rem',
            color: '#ea580c',
            textDecoration: 'none',
            fontWeight: '600',
          }}>
            Learn how to play →
          </Link>
        </div>
      </div>
    </div>
  )
}

export default StartScreen
